import type { Language } from '@offer-catalog/services/i18n'
import type { CollectionResponse } from '@/types/bff'
import { apiBff } from '@/api'
import { fetchAllDdfsCollection } from './collections'

export type DdfsQuery = Record<string, string | readonly string[]>

export interface DdfsLabel {
  id: number
  name: string
}

export interface Brand extends DdfsLabel {}

export interface DdfsProductNature extends DdfsLabel {}

export interface Sport extends DdfsLabel {}

export interface SportGroup extends DdfsLabel {}

export interface Benefit extends DdfsLabel {
  description: string
}

export interface ProductPart extends DdfsLabel {}

export interface Material extends DdfsLabel {}

export interface BuisnessColor extends DdfsLabel {
  hex_code: string
}

function serializeQuery(query: DdfsQuery): string {
  return Object.entries(query)
    .flatMap(([key, value]) => {
      const values = Array.isArray(value) ? value : [value]
      return values.map(item => `${key}=${item}`)
    })
    .join('&')
}

function buildDdfsPath(resource: string, query: DdfsQuery): string {
  const serializedQuery = serializeQuery(query)
  const querySuffix = serializedQuery ? `?${serializedQuery}` : ''
  return `ddfs/${resource}${querySuffix}`
}

export async function fetchDdfsCollection<T>(
  resource: string,
  query: DdfsQuery,
  currentLanguage: Language,
): Promise<CollectionResponse<T>> {
  return apiBff.callDirectBFF<CollectionResponse<T>>(
    'GET',
    buildDdfsPath(resource, query),
    undefined,
    {
      'accept-language': currentLanguage,
    },
  )
}

export async function fetchAllDdfsResource<T>(
  resource: string,
  currentLanguage: Language,
  query: DdfsQuery = {},
): Promise<T[]> {
  return fetchAllDdfsCollection((page, itemsPerPage) => fetchDdfsCollection<T>(
    resource,
    {
      page: String(page),
      itemsPerPage: String(itemsPerPage),
      ...query,
    },
    currentLanguage,
  ))
}
